(() => {
  const fold = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
  const productCache = new Map();
  async function initialize(section) {
    if (section.dataset.catalogReady) return;
    section.dataset.catalogReady = 'true';
    const input = section.querySelector('[data-visualizer-page-search]');
    const shape = section.querySelector('[data-visualizer-shape-filter]');
    const grid = section.querySelector('[data-visualizer-catalog-grid]');
    const count = section.querySelector('[data-visualizer-page-count]');
    const more = section.querySelector('[data-visualizer-page-load-more]');
    const empty = section.querySelector('[data-visualizer-page-empty]');
    const editor = section.querySelector('[data-visualizer-shared-editor] [data-heikoa-visualizer]');
    let limit = Number(section.dataset.initialCount) || 8;
    let catalog;
    let selectionSequence = 0;
    try {
      const response = await fetch(section.dataset.catalogUrl, { credentials: 'omit' });
      if (!response.ok) throw new Error('catalog-unavailable');
      catalog = await response.json();
    } catch {
      count.textContent = section.dataset.errorLabel;
      return;
    }
    const priority = (product) => product.imageUrl ? 2 : product.asset ? 1 : 0;
    const products = catalog.products.sort((a, b) => priority(b) - priority(a));
    const money = new Intl.NumberFormat(document.documentElement.lang || 'fr', {
      style: 'currency', currency: section.dataset.currency || 'EUR'
    });
    async function choose(product, button) {
      if (!editor) return;
      const sequence = ++selectionSequence;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        let details = productCache.get(product.handle);
        if (!details) {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(product.handle) + '.js');
          if (!response.ok) throw new Error('product-unavailable');
          details = await response.json();
          productCache.set(product.handle, details);
        }
        if (sequence !== selectionSequence) return;
        const variants = details.variants.filter((variant) =>
          !product.excludedVariants?.map(String).includes(String(variant.id))).map((variant) => ({
          id: variant.id, title: variant.title, available: variant.available,
          options: variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean),
          price: variant.price
        }));
        if (!variants.some((variant) => variant.available)) throw new Error('product-sold-out');
        const imageUrl = product.imageUrl || new URL(product.asset,
          new URL(section.dataset.catalogUrl, window.location.href)).href;
        editor.dispatchEvent(new CustomEvent('heikoa:activate'));
        editor.dispatchEvent(new CustomEvent('heikoa:select-product', {
          detail: { ...product, imageUrl, variants,
            optionNames: details.options.map((option) => typeof option === 'string' ? option : option.name),
            url: (window.Shopify?.routes?.root || '/') + 'products/' + product.handle }
        }));
      } catch {
        count.textContent = section.dataset.errorLabel;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
    function card(product) {
      const article = document.createElement('article');
      article.className = 'heikoa-visualizer-page__card';
      const image = document.createElement('img');
      image.className = 'heikoa-visualizer-page__image';
      const url = new URL(product.thumbnail);
      url.searchParams.set('width', '480');
      image.src = url.href;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 480;
      image.height = 360;
      article.append(image);
      const content = document.createElement('div');
      content.className = 'heikoa-visualizer-page__content';
      const heading = document.createElement('h3');
      const link = document.createElement('a');
      link.href = (window.Shopify?.routes?.root || '/') + 'products/' + product.handle;
      link.textContent = product.title;
      heading.append(link);
      content.append(heading);
      if (Number.isFinite(product.price) && section.dataset.currency === (catalog.currency || 'EUR')) {
        const price = document.createElement('p');
        price.className = 'heikoa-visualizer-page__price';
        price.textContent = money.format(product.price);
        content.append(price);
      }
      const button = document.createElement('button');
      button.className = 'heikoa-visualizer__launch';
      button.type = 'button';
      const ready = Boolean(product.imageUrl || product.asset);
      button.textContent = ready ? section.dataset.previewLabel : section.dataset.unavailableLabel;
      button.disabled = !ready;
      if (ready) button.addEventListener('click', () => choose(product, button));
      content.append(button);
      article.append(content);
      return article;
    }
    function render(reset) {
      if (reset) limit = Number(section.dataset.initialCount) || 8;
      const query = fold(input.value.trim());
      const matches = products.filter((product) => (!query || fold(product.title).includes(query)) &&
        (!shape.value || product.shape === shape.value));
      grid.replaceChildren(...matches.slice(0, limit).map(card));
      count.textContent = section.dataset.countLabel.replace('[shown]', String(Math.min(limit, matches.length))).replace('[total]', String(matches.length));
      more.hidden = matches.length <= limit;
      empty.hidden = matches.length > 0;
    }
    input.addEventListener('input', () => render(true));
    shape.addEventListener('change', () => render(true));
    more.addEventListener('click', () => {
      limit += Number(section.dataset.loadCount) || 8;
      render(false);
    });
    render(true);
  }
  const run = (scope) => scope.querySelectorAll('[data-heikoa-visualizer-catalog]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document));
  else run(document);
  document.addEventListener('shopify:section:load', (event) => run(event.target));
})();
